var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "badge",
      class: _vm.badgeClass,
      attrs: { "data-test": "badge-label" }
    },
    [_vm._v(" " + _vm._s(_vm.titleCase(_vm.value)) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }